import { t } from 'i18next'

import { ResidentAppError } from '../../../../common/error'
import {
  ContractTerminationReason,
  LegacyContractTerminationReason,
} from '../../../../common/types'

type TerminationReasonLabelValue =
  | ContractTerminationReason
  | LegacyContractTerminationReason
  | ''

export const useTerminationReasonToLabel = () => {
  const terminationReasonToLabel = (reason: TerminationReasonLabelValue) => {
    switch (reason) {
      case LegacyContractTerminationReason.BUYING_PROPERTY:
        return t('terminateContract:terminateContractReasons.buyingProperty')
      case LegacyContractTerminationReason.MOVE_TO_ANOTHER_RENTAL:
        return t(
          'terminateContract:terminateContractReasons.moveToAnotherRental'
        )
      case LegacyContractTerminationReason.MOVE_TO_RIGHT_OF_OCCUPANCY:
        return t(
          'terminateContract:terminateContractReasons.moveToRightOfOccupancy'
        )
      case LegacyContractTerminationReason.MOVE_TO_CARE_HOME_OR_HOSPITAL:
        return t(
          'terminateContract:terminateContractReasons.moveToCareHomeOrHospital'
        )
      case LegacyContractTerminationReason.MOVE_TO_ANOTHER_APARTMENT_OF_SAME_OWNER:
        return t(
          'terminateContract:terminateContractReasons.moveToAnotherApartmentOfSameOwner'
        )
      case ContractTerminationReason.MOVE_DUE_WORK:
        return t('terminateContract:terminateContractReasons.moveDueWork')
      case ContractTerminationReason.MOVE_TO_ANOTHER_MUNICIPALITY:
        return t(
          'terminateContract:terminateContractReasons.moveToAnotherMunicipality'
        )
      case ContractTerminationReason.FAMILY_SIZE_CHANGE:
        return t('terminateContract:terminateContractReasons.familySizeChange')
      case ContractTerminationReason.APARTMENT_SIZE:
        return t('terminateContract:terminateContractReasons.apartmentSize')
      case ContractTerminationReason.POOR_APARTMENT_CONDITION:
        return t(
          'terminateContract:terminateContractReasons.poorApartmentCondition'
        )
      case ContractTerminationReason.POOR_APARTMENT_EQUIPMENT_OR_PROPERTIES:
        return t(
          'terminateContract:terminateContractReasons.poorApartmentEquipmentOrProperties'
        )
      case ContractTerminationReason.POOR_PROPERTY_CONDITION:
        return t(
          'terminateContract:terminateContractReasons.poorPropertyCondition'
        )
      case ContractTerminationReason.POOR_PROPERTY_MAINTENANCE:
        return t(
          'terminateContract:terminateContractReasons.poorPropertyMaintenance'
        )
      case ContractTerminationReason.HOUSING_COSTS:
        return t('terminateContract:terminateContractReasons.housingCosts')
      case ContractTerminationReason.DISTURBING_NEIGHBOURS_OR_BUILDING:
        return t(
          'terminateContract:terminateContractReasons.disturbingNeighboursOrBuilding'
        )
      case ContractTerminationReason.AREA_POOR_SERVICES:
        return t('terminateContract:terminateContractReasons.areaPoorServices')
      case ContractTerminationReason.POOR_TRANSPORTATION_OPTIONS:
        return t(
          'terminateContract:terminateContractReasons.poorTransportationOptions'
        )
      case ContractTerminationReason.APARTMENT_DOES_NOT_MEET_NEEDS:
        return t(
          'terminateContract:terminateContractReasons.apartmentDoesNotMeetNeeds'
        )
      case ContractTerminationReason.APARTMENT_TEMPERATURE:
        return t(
          'terminateContract:terminateContractReasons.apartmentTemperature'
        )
      case ContractTerminationReason.APARTMENT_LOCATION:
        return t('terminateContract:terminateContractReasons.apartmentLocation')
      case ContractTerminationReason.STUDIES_END:
        return t('terminateContract:terminateContractReasons.studiesEnd')
      case ContractTerminationReason.RIGHT_OF_OCCUPANCY_ENDS:
        return t(
          'terminateContract:terminateContractReasons.rightOfOccupancyEnds'
        )
      case ContractTerminationReason.AREA_DISTURBANCES:
        return t('terminateContract:terminateContractReasons.areaDisturbances')
      case ContractTerminationReason.HEALTH_REASONS:
        return t('terminateContract:terminateContractReasons.healthReasons')
      case ContractTerminationReason.DEATH:
        return t('terminateContract:terminateContractReasons.death')
      case ContractTerminationReason.EVICTION:
        return t('terminateContract:terminateContractReasons.eviction')
      case ContractTerminationReason.RENOVATION:
        return t('terminateContract:terminateContractReasons.renovation')
      case ContractTerminationReason.BUSINESS_CLOSURE:
        return t('terminateContract:terminateContractReasons.businessClosure')
      case ContractTerminationReason.BUSINESS_CLOSURE_IN_MUNICIPALITY:
        return t(
          'terminateContract:terminateContractReasons.businessClosureInMunicipality'
        )
      case ContractTerminationReason.BUSINESS_STRUCTURE_CHANGE:
        return t(
          'terminateContract:terminateContractReasons.businessStructureChange'
        )
      case ContractTerminationReason.SPACE_NEEDS_CHANGE:
        return t('terminateContract:terminateContractReasons.spaceNeedsChange')
      case ContractTerminationReason.MOVE_TO_MORE_AFFORDABLE_BUSINESS_PREMISES_IN_MUNICIPALITY:
        return t(
          'terminateContract:terminateContractReasons.moveToMoreAffordableBusinessPremisesInMunicipality'
        )
      case ContractTerminationReason.OTHER:
        return t('terminateContract:terminateContractReasons.other')
      case ContractTerminationReason.UNKNOWN:
        return t('terminateContract:terminateContractReasons.unknown')
      default:
        throw ResidentAppError.ClientError('UNKNOWN', {
          message: `Unknown termination reason: ${reason}`,
        })
    }
  }

  return { terminationReasonToLabel }
}
